module.exports = __webpack_public_path__ + "img/Univision.796e3a1e.png";